import { render, staticRenderFns } from "./MonitoringBreakdown.vue?vue&type=template&id=22ed6342"
import script from "./MonitoringBreakdown.vue?vue&type=script&lang=js"
export * from "./MonitoringBreakdown.vue?vue&type=script&lang=js"
import style0 from "./MonitoringBreakdown.vue?vue&type=style&index=0&id=22ed6342&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports